import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { MasterFSPEntity } from "domain/entity/MasterFSP/MasterFSPEntity";
import { OpsAgentInfoEntity } from "domain/entity/MasterFSP/OpsAgentInfoEntity";
import { axiosGetData, axiosPostData, axiosPutData } from "../axios/AxiosBasicImpl";
import companyAxiosInstance from "../axios/companyAxiosInstance";
import { MasterFSPRepository } from "./MasterFSPRepo";

/**
 * For template
 * @returns 
 */
export const MasterFSPRepoImpl = (): MasterFSPRepository => {
    const url = '/v1/masterFSP';

    const getEntities = async (): Promise<MasterFSPEntity[]> => {
        return await axiosGetData(companyAxiosInstance, url, []).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });

    }

    const getRejectedEntities = async (): Promise<MasterFSPEntity[]> => {
        return await axiosGetData(companyAxiosInstance, `${url}/rejectedFsp`, []).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });

    }

    const getPendingApprovalEntities = async (): Promise<MasterFSPEntity[]> => {
        return await axiosGetData(companyAxiosInstance, `${url}/pendingApprovalFsp`, []).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });

    }

    const getEntityByKey = async (key: string): Promise<MasterFSPEntity> => {
        return await axiosGetData(companyAxiosInstance, `${url}/${key}`, []).then(res => {
            return res.data;
        }).catch(err => {
            return null;
        });
    }

    const createEntity = async (newData: MasterFSPEntity): Promise<ResponseEntity> => {
        return await axiosPostData(companyAxiosInstance, url, newData);
    }

    const updateEntity = async (updatedData: MasterFSPEntity): Promise<ResponseEntity> => {
        return await axiosPutData(companyAxiosInstance, `${url}`, updatedData);
    }

    const deleteEntity = async (deleteData: MasterFSPEntity[]): Promise<ResponseEntity> => {
        const newUrl = url + '/delete';
        return await axiosPostData(companyAxiosInstance, `${newUrl}`, deleteData).then(res => {
            return res;
        }).catch(err => {
            return null;
        });
    }

    const applyEntity = async (applyData: MasterFSPEntity[]): Promise<ResponseEntity> => {
        const newUrl = url + '/apply';
        return await axiosPostData(companyAxiosInstance, `${newUrl}`, applyData);
    }

    const getLoadAgentCode = async (): Promise<OpsAgentInfoEntity[]> => {
        const newUrl = url + '/loadAgentCode';
        return await axiosGetData(companyAxiosInstance, newUrl, []).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });
    }

    const submitEntity = async (submitData: MasterFSPEntity[]): Promise<ResponseEntity> => {
        const newUrl = url + '/submit';
        return await axiosPostData(companyAxiosInstance, `${newUrl}`, submitData);
    }

    const approveEntity = async (submitData: MasterFSPEntity[]): Promise<ResponseEntity> => {
        const newUrl = url + '/approve';
        return await axiosPostData(companyAxiosInstance, `${newUrl}`, submitData);
    }

    const rejectEntity = async (submitData: MasterFSPEntity): Promise<string> => {
        const newUrl = url + '/reject';
        return await axiosPostData(companyAxiosInstance, `${newUrl}`, submitData);
    }

    const searchMasterFSP = async (searchCriteria: MasterFSPEntity): Promise<MasterFSPEntity[]> => {
        const newUrl = url + '/search';
        return await axiosPostData(companyAxiosInstance, `${newUrl}`, searchCriteria).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });

    }


    return {
        getEntities: getEntities,
        getRejectedEntities: getRejectedEntities,
        getPendingApprovalEntities: getPendingApprovalEntities,
        getEntityByKey: getEntityByKey,
        createEntity: createEntity,
        updateEntity: updateEntity,
        deleteEntity: deleteEntity,
        applyEntity: applyEntity,
        getLoadAgentCode: getLoadAgentCode,
        submitEntity: submitEntity,
        approveEntity: approveEntity,
        rejectEntity: rejectEntity,
        searchMasterFSP: searchMasterFSP,
    }
}